// extracted by mini-css-extract-plugin
module.exports =  {"wrapper":"NewsDetail-NewsDetail-wrapper-d81788e6"};